import React from 'react';
import { BaseQueryOpts } from '../baseTypes';
import { useUserQuery, useUserProfileQuery } from './user.queries';


export const useUserWithProfileQuery = (userId?: string, opts?: BaseQueryOpts) => {
  const { data: user } = useUserQuery(userId, {
    ...opts,
    enabled: !!userId,
  });
  const { data: profile, isLoading: isProfileLoading, isInitialLoading: isProfileInitialLoading } = useUserProfileQuery(userId, {
    ...opts,
    enabled: !!user?.id,
  });

  const data = React.useMemo(() => {
    if (!user || !profile) {
      return null;
    }

    return {
      user: user,
      profile: profile,
    };
  }, [ user, profile ]);

  return {
    data,
    isLoading: isProfileLoading,
    isInitialLoading: isProfileInitialLoading,
  };
};
